import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { StObservationItem } from '@/modules/shared/components/observation-item/ObservationItem'

import type { QuestionAnswer } from '@/modules/questionnaire/types'

type DefaultAnswerProps = {
  title: string
  description: string
  answer: QuestionAnswer
  /** Same padded neutral block as observation list items */
  medicationStyleContent?: boolean
}

export const DefaultAnswer = ({ title, description, answer, medicationStyleContent }: DefaultAnswerProps) => {
  const theme = useTheme()
  const body = answer.text ?? answer.value

  return (
    <FlexColumn key={answer.linkId} gap={theme.UI.Spacing.Space2}>
      <Span type='BodyMediumBold' color={theme.Colors.Neutrals.Darkest}>
        {`${title && description ? `${title}: ` : title || ''}${description}`}
      </Span>
      {medicationStyleContent ? (
        <StObservationItem type='BodyMediumRegular' color={theme.Colors.Neutrals.Darker}>
          {body}
        </StObservationItem>
      ) : (
        <Span type='BodyMediumRegular'>{body}</Span>
      )}
    </FlexColumn>
  )
}
